import { HttpClient } from "@angular/common/http";
import { DestroyRef, Injectable, computed, inject, signal } from "@angular/core";
import { LoadingService } from "../../shared/services/loading.service";
import { SelectOption, SelectOptionWithSelected } from "../../shared/interfaces/select-option";
import { tap } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class PortfolioService {
    private api: string = `investments/poolInvestments/portfolio/`;
    #httpClient = inject(HttpClient);
    #loadingService = inject(LoadingService);

    private _destroyRef = inject(DestroyRef);
    private _portfolios = signal<SelectOption[]>([]);

    readonly portfolios = this._portfolios.asReadonly();
    readonly portfoliosWithSelect = computed(() => {
        return this._portfolios().map((option) => {
            return {
                ...option,
                selected: false
            } as SelectOptionWithSelected;
        });
    });

    getPortfolios() {
        this.#loadingService.showLoadingIndicator();
        return this.#httpClient.get<SelectOption[]>(`${this.api}get-portfolios`).pipe(
            tap(response => {
                this._portfolios.set(response);
                this.#loadingService.hideLoadingIndicator();
            })
        );
    }

    // getPortfolios() {
    //     this.#loadingService.showLoadingIndicator();
    //     this.#httpClient.get<Array<SelectOption>>(`${this.api}get-portfolios/`).subscribe((response) => {
    //         this._portfolios.set(response);
    //         this.#loadingService.hideLoadingIndicator();
    //     });
    // }
}
